module.exports = __webpack_public_path__ + "img/cup.db468f49.png";